import React from 'react';
import PropTypes from 'prop-types';
import { Spin, Tooltip } from 'antd';
import moment from 'moment';
import './EstimateStatusComponent.scss';
import { EstimateFlow } from '../../../../sharedTypes/EstimateTypes';
import { ESTIMATE_STATUS } from '../../../../utils/constants';

const getFormattedDate = (date: string): string => (date ? moment(date).format('DD/MM/YYYY [às] HH:mm') : '');
const getFormattedscheduleDate = (date: string): string => (date ? moment(date).utc().format('DD/MM/YYYY') : '');

const EstimateStatusComponent = (props): JSX.Element => {
  const {
    loading,
    statusesList,
    currentStatusIndex,
    canceled,
  }: {
    loading: boolean,
    statusesList: Array<EstimateFlow>,
    currentStatusIndex: number,
    canceled: boolean,
  } = props;

  return (
    <div className="EstimateStatusComponent">
      <Spin
        tip="Carregando..."
        spinning={loading}
      >
        {
          statusesList.map((value: EstimateFlow, index: number): JSX.Element => {
            const lastItem = index === currentStatusIndex ? 'last-item' : '';
            const statusItem = index <= currentStatusIndex
              && (canceled ? 'canceled-item' : 'completed-item');

            return (
              <div className="status-item" key={`status-item-${value.id}`}>
                {
                  lastItem
                    ? (
                      <div className={`${statusItem} last-item`}>
                        <div className="item-icon-container">
                          <div className="item-icon">
                            {ESTIMATE_STATUS.find((item) => item.id === value.id)?.icon}
                          </div>
                        </div>
                        <div className="item-complement" />
                      </div>
                    )
                    : (
                      <div className={`${statusItem}`} style={{ height: 84 }}>
                        <div className="item-icon-container-dot">
                          <div className="item-dot-container">
                            <div className="item-dot" />
                          </div>
                        </div>
                        <div className="item-complement-dot" />
                      </div>
                    )
                }
                <div className={`${statusItem} ${lastItem} item-text`}>
                  <div className="item-name">
                    {
                      value.scheduleDate
                        ? `Agendado para ${getFormattedscheduleDate(value.scheduleDate)}`
                        : value.stepName
                    }
                  </div>

                  <div className="item-time">{getFormattedDate(value.date)}</div>

                  {
                    lastItem
                      && canceled
                      && value.stepName !== 'Orçamento expirado'
                      ? (
                        <div className="cancellation-reason">
                          <Tooltip data-html="true" title={value.reasonRefuses} placement="bottom">
                            <span>Motivo do cancelamento</span>
                          </Tooltip>
                        </div>
                      )
                      : null
                  }
                </div>
              </div>
            );
          })
        }
      </Spin>
    </div>
  );
};

EstimateStatusComponent.propTypes = {
  loading: PropTypes.bool.isRequired,
  statusesList: PropTypes.arrayOf(PropTypes.any).isRequired,
  currentStatusIndex: PropTypes.number.isRequired,
  canceled: PropTypes.bool.isRequired,
};

EstimateStatusComponent.defaultProps = {};

export default EstimateStatusComponent;
